import { useState } from 'react'
import { useClickAway } from "@uidotdev/usehooks";

export function useClickOut(){
    const [isOpen, setIsOpen] = useState(false)
    const ref: any = useClickAway(() => setIsOpen(false));

    return {isOpen, setIsOpen, ref};
}
